import React from 'react';
import {Route, Switch} from 'react-router-dom';
import EventoVisualizar from './pages/EventoVisualizar';
import EventoContribuicaoForm from './pages/EventoContribuicaoForm';

import './assets/evento-visualizar.scss';
import './assets/evento-contribuicao.scss';
import './assets/modal-ciencia-evento.scss';

const EventoPage: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path="/evento/visualizar" exact={true} component={EventoVisualizar}/>
        <Route path="/evento/contribuicao" exact={true} component={EventoContribuicaoForm}/>
      </Switch>
    </>
  );
};
export default EventoPage;
